/**
 * Ephemeral per-visit cache (routine, AQI, recommendations, UI state).
 * Avoids persisting session data in localStorage on shared kiosk devices.
 */

const routineBySession = new Map();
const aqiBySession = new Map();
const recommendationStatusBySession = new Map();
const treatmentRecommendationsBySession = new Map();
const sideViewBySession = new Map();

export function getSalonRoutineCache(sessionId) {
  if (!sessionId) return null;
  return routineBySession.get(String(sessionId)) || null;
}

export function setSalonRoutineCache(sessionId, payload) {
  if (!sessionId || !payload) return;
  routineBySession.set(String(sessionId), payload);
}

export function getSalonAqiCache(sessionId) {
  if (!sessionId) return null;
  return aqiBySession.get(String(sessionId)) || null;
}

export function setSalonAqiCache(sessionId, payload) {
  if (!sessionId || !payload) return;
  aqiBySession.set(String(sessionId), payload);
}

export function getSalonRecommendationStatusCache(sessionId) {
  if (!sessionId) return null;
  return recommendationStatusBySession.get(String(sessionId)) || null;
}

export function setSalonRecommendationStatusCache(sessionId, payload) {
  if (!sessionId || !payload) return;
  recommendationStatusBySession.set(String(sessionId), payload);
}

export function getSalonTreatmentRecommendationsCache(sessionId) {
  if (!sessionId) return null;
  return treatmentRecommendationsBySession.get(String(sessionId)) || null;
}

export function setSalonTreatmentRecommendationsCache(sessionId, payload) {
  if (!sessionId || !payload) return;
  treatmentRecommendationsBySession.set(String(sessionId), payload);
}

export function getSalonSideViewCache(sessionId) {
  if (!sessionId) return null;
  return sideViewBySession.get(String(sessionId)) || null;
}

export function setSalonSideViewCache(sessionId, payload) {
  if (!sessionId || !payload) return;
  sideViewBySession.set(String(sessionId), payload);
}

export function clearSalonSideViewCache(sessionId) {
  if (!sessionId) return;
  sideViewBySession.delete(String(sessionId));
}

export function clearSalonVisitMemoryCache(sessionId) {
  if (!sessionId) return;
  const key = String(sessionId);
  routineBySession.delete(key);
  aqiBySession.delete(key);
  recommendationStatusBySession.delete(key);
  treatmentRecommendationsBySession.delete(key);
  sideViewBySession.delete(key);
}

/** Remove legacy localStorage keys from prior builds. */
export function purgeLegacySalonVisitLocalStorage() {
  const prefixes = [
    'saloon_routine_',
    'salon_recommendation_status_',
    'saloon_aqi_',
    'salon_aqi_',
    'salon_treatment_recommendations_',
    'saloon_side_focus_',
    'enterprise_salon_analysis_cache_',
    'enterprise_salon_analysis_pending_saves_',
    'enterprise_salon_pending_save_analysis_v1',
    'enterprise_salon_selected_service_names',
  ];
  try {
    const keys = [];
    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (!key) continue;
      if (prefixes.some((prefix) => key.startsWith(prefix) || key === prefix)) keys.push(key);
    }
    keys.forEach((key) => localStorage.removeItem(key));
  } catch {
    /* ignore */
  }
}
